import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-template21b12',
  templateUrl: './template21b12.component.html',
  styleUrls: ['./template21b12.component.css']
})
export class Template21b12Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
